import { bindContactForms } from "@/scripts/sections/contact-form-handler.js"

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bindContactForms)
} else {
  bindContactForms()
}

function hubspotContactStyleCss() {
  const template = window.templateName
  const isLightForm =
    template && (template === "article" || template === "contact-us")
  const fg = isLightForm
    ? "rgb(var(--color-primary-black))"
    : "rgb(var(--color-primary-white))"
  const focusBorder = isLightForm
    ? "rgb(var(--color-accents-green))"
    : "rgb(var(--color-accents-yellow))"

  return `
          form[class*="_formFieldset"] {
            flex-direction: row !important;
            row-gap: 32px !important;
            column-gap: 20px !important;
            padding: 0 !important;
          }

          section[data-sizing="form-wrapper"] {
            max-width: 100% !important;
          }

          section[data-sizing="form-wrapper"] input::placeholder,
          section[data-sizing="form-wrapper"] textarea::placeholder {
            color: ${fg};
            opacity: 1;
            font-weight: 400;
            font-size: 0.875rem;
            line-height: 200%;
            letter-spacing: 0.4px;
          }

          section[data-sizing="form-wrapper"] form div:has(input) {
            width: calc(50% - 10px);
          }

          section[data-sizing="form-wrapper"] form div:has(textarea) {
            width: 100%;
          }

          section[data-sizing="form-wrapper"] form div:has(input[id="custom#how_did_you_hear_about_us"]) {
            width: 100%;
          }

          section[data-sizing="form-wrapper"] input {
            box-sizing: border-box;
            max-width: calc(100% - 1px);
            width: 100%;
            position: relative;
            min-height: 3.25rem;
            border-width: 1px;
            border-radius: 2.5rem;
            padding-block: 0.75rem;
            border-style: solid;
            border-color: ${fg};
            padding-inline: 1.5rem;
            font-size: 0.875rem;
            line-height: 1.5rem;
            background-color: transparent;
            color: ${fg};
            margin-top: 1px;
            margin-inline: 0.5px;
          }

          section[data-sizing="form-wrapper"] div[class*="_withError"] input,
          section[data-sizing="form-wrapper"] div[class*="_withError"] textarea  {
            border-width: 1px;
            box-shadow: unset;
            border-color: rgba(var(--color-utility-error));
          }

          section[data-sizing="form-wrapper"] output {
            display: none;
          }

          section[data-sizing="form-wrapper"] textarea {
            box-sizing: border-box;
            max-width: calc(100% - 1px);
            width: 100%;
            position: relative;
            min-height: 10rem;
            border-width: 1px;
            border-radius: 1rem;
            border-style: solid;
            border-color: ${fg};
            padding-inline: 1.5rem;
            padding-top: 1.25rem;
            padding-bottom: 1rem;
            margin-inline: 0.5px;
            font-size: 0.875rem;
            line-height: 1.5rem;
            background-color: transparent;
            color: ${fg};
          }

          section[data-sizing="form-wrapper"] input:focus,
          section[data-sizing="form-wrapper"] input:focus-visible,
          section[data-sizing="form-wrapper"] textarea:focus,
          section[data-sizing="form-wrapper"] textarea:focus-visible {
            outline-width: 0px;
            border: 1px solid;
            border-color: ${focusBorder};
            box-shadow: unset;
          }

          section[data-sizing="form-wrapper"] input + label,
          section[data-sizing="form-wrapper"] textarea + label {
            display: none;
          }

          section[data-sizing="form-wrapper"] button {
            position: relative;
            font-size: 0.8125rem;
            line-height: 1rem;
            font-weight: 700;
            letter-spacing: 0.4px;
            text-align: center;
            text-transform: uppercase;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: 3.75rem;
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 300ms;
            background-color: transparent;
            border-width: 1px;
            border-style: solid;
            border-color: ${fg};
            padding-inline: 2rem;
            padding-block: 1rem;
            color: ${fg};
            width: 100%;
            box-sizing: border-box;
          }

          section[data-sizing="form-wrapper"] button:hover {
            border-color: ${fg};
            background-color: ${fg};
            color: ${isLightForm ? "rgb(var(--color-primary-white))" : "rgb(var(--color-primary-black))"};
            filter: none;
            border-width: 1px;
            border-style: solid;
          }

          section[data-sizing="form-wrapper"] section[data-testid="banner-success"] h2 {
            font-family: var(--font-body);
            font-weight: 700;
            font-size: 0.875rem;
            line-height: 1.25rem;
            letter-spacing: 1.4px;
            text-transform: uppercase;
            justify-content: left;
          }

          section[data-sizing="form-wrapper"] section[data-testid="banner-success"] p {
            font-family: var(--font-heading);
            font-size: 2.5rem;
            line-height: 3.5rem;
            letter-spacing: 0.6px;
            text-transform: none;
            text-align: left;
          }

          @media (max-width: 990px) {
            form[class*="_formFieldset"] {
              flex-direction: column !important;
              gap: 14px !important;
            }

            section[data-sizing="form-wrapper"] form div:has(input) {
              width: 100%;
            }

            div[data-testid="app-router"] {
              display: block;
            }

            section[data-sizing="form-wrapper"] section[data-testid="banner-success"] h2 {
              font-size: 0.6875rem;
              line-height: 1rem;
              letter-spacing: 1px;
            }

            section[data-sizing="form-wrapper"] section[data-testid="banner-success"] p {
              font-size: 1.625rem;
                line-height: 2.25rem;
            }
          }
        `
}

function patchHubSpotContactForm(formEmbed) {
  const shadowRoot = formEmbed.shadowRoot
  if (!shadowRoot) return

  if (!formEmbed.dataset.hsContactUsStyle) {
    const style = document.createElement("style")
    style.textContent = hubspotContactStyleCss()
    shadowRoot.appendChild(style)
    formEmbed.dataset.hsContactUsStyle = "1"
  }

  const formWrap = shadowRoot.querySelector(
    'section[data-sizing="form-wrapper"]'
  )
  if (formWrap) {
    formWrap.style.maxWidth = "100%"
  }

  const fieldset = shadowRoot.querySelector('form[class*="_formFieldset"]')
  if (!fieldset || formEmbed.dataset.hsContactUsFieldset) return

  fieldset.style.flexWrap = "wrap"
  fieldset.querySelectorAll("input").forEach((input) => {
    const label = input.nextElementSibling
    if (label) input.placeholder = label.innerText
  })
  fieldset.querySelectorAll("textarea").forEach((textarea) => {
    const label = textarea.nextElementSibling
    if (label) textarea.placeholder = label.innerText
  })
  formEmbed.dataset.hsContactUsFieldset = "1"
}

function wireHubSpotContactForm(formEmbed) {
  const shadowRoot = formEmbed.shadowRoot
  if (!shadowRoot) return

  if (formEmbed.dataset.hsContactUsWired) return
  formEmbed.dataset.hsContactUsWired = "1"

  const mo = new MutationObserver(() => {
    patchHubSpotContactForm(formEmbed)
    if (formEmbed.dataset.hsContactUsFieldset) {
      mo.disconnect()
    }
  })
  mo.observe(shadowRoot, { childList: true, subtree: true })
  patchHubSpotContactForm(formEmbed)
  if (formEmbed.dataset.hsContactUsFieldset) {
    mo.disconnect()
  }
}

function initContactUsHubSpot() {
  const formEmbed = document.querySelector(
    ".contact-us__section .contact-us__form form-embed"
  )
  if (!formEmbed) return

  if (formEmbed.shadowRoot) {
    wireHubSpotContactForm(formEmbed)
    return
  }

  const poll = setInterval(() => {
    if (formEmbed.shadowRoot) {
      clearInterval(poll)
      wireHubSpotContactForm(formEmbed)
    }
  }, 50)

  setTimeout(() => clearInterval(poll), 15000)
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initContactUsHubSpot)
} else {
  initContactUsHubSpot()
}
